// Module
var code = "<gh-indicator [gh-value]=\"$ctrl.indicators.loading\" gh-message=\"{{ 'loading' | localize }}\"></gh-indicator><img ng-if=\"!$ctrl.indicators.loading\" ng-src=\"{{$ctrl.url}}\" ng-attr-style=\"max-width: {{$ctrl.maxWidth}}px; max-height: {{$ctrl.maxHeight}}px\"/>";
// Exports
module.exports = code;